module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic_1.06e43cea.woff2";